"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushDataLayerEvent = void 0;
/**
 * Validates that window object exists
 *
 * eventObject expects at the bare minimum event property with a name
 * can pass any other property along deemed necessary by Digital tools for the events metadata
 * @param {{ event: string }} eventObject
 */
const pushDataLayerEvent = (eventObject) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ...eventObject });
    }
};
exports.pushDataLayerEvent = pushDataLayerEvent;
//# sourceMappingURL=datalayer.js.map